import React, { Suspense } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/error-boundary.component";
import { PersistGate } from "redux-persist/integration/react";
import PageLoader from "./components/page-loader.component";
import { createBrowserHistory } from "history";
import store, { persistor } from "./store";
import WebRoutes from "./web-routes.component";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const history = createBrowserHistory();

const PageLoading = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <PageLoader />
    </div>
  );
};

const ThemedApp = () => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        light: "#f1d6ae",
        main: "#ffb547",
        dark: "#b9812e",
      },
      secondary: {
        light: "#82bfee",
        main: "#1877f2",
        dark: "#1563a0",
      },
    },
    typography: {
      fontFamily: [
        "Inter",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      fontSize: 12,
    },
  });
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <MuiThemeProvider theme={theme}>
        <ErrorBoundary>
          <PersistGate loading={<PageLoading />} persistor={persistor}>
            <Router history={history}>
              <Suspense fallback={<PageLoading />}>
                <ToastContainer />
                <WebRoutes />
              </Suspense>
            </Router>
          </PersistGate>
        </ErrorBoundary>
      </MuiThemeProvider>
    </div>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ThemedApp />
    </Provider>
  );
}

export default App;
